import {
	VoiceResponseDTO,
	MACEDONIAN_COLLECTION_ID,
	COSTA_RICA_COLLECTION_ID,
	MALAYSIA_COLLECTION_ID,
} from '@core/api/dtos/response/campaign/voice'
import { Voice } from '@core/api/entities/campaign/voice'

export class VoiceMapper {
	static getAccent(data: VoiceResponseDTO): string | undefined {
		// Check if voice is in Costa Rica collection - this takes priority
		if (data.collection_ids?.includes(COSTA_RICA_COLLECTION_ID)) {
			return 'Costa Rica'
		}

		// Check if voice is in Macedonian collection - this takes priority
		if (data.collection_ids?.includes(MACEDONIAN_COLLECTION_ID)) {
			return 'macedonian'
		}

		// Check if voice is in Malaysia collection
		if (data.collection_ids?.includes(MALAYSIA_COLLECTION_ID)) {
			return 'Malaysia'
		}

		// Use labels.accent for all other voices
		return data.labels?.accent
	}

	static toEntity(data: VoiceResponseDTO): Voice {
		return new Voice({
			voiceId: data.voice_id,
			name: data.name,
			category: data.category,
			previewUrl: data.preview_url || data.samples?.[0]?.preview_url,
			accent: this.getAccent(data),
			description: data.labels?.description,
			age: data.labels?.age,
			gender: data.labels?.gender,
			useCase: data.labels?.use_case,
			collectionIds: data.collection_ids,
		})
	}

	static toEntities(data: VoiceResponseDTO[]): Voice[] {
		return data.map((item) => this.toEntity(item))
	}
}
